

import React, { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

function BhaktamarDeclaration() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    agree: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const isValidMobile = (num) => /^[0-9]{10}$/.test(num);
  

  async function extractErrorMessage(err) {
    if (!err.response) return "❌ सर्वर से संपर्क नहीं हो सका।";
    try {
      const text = await err.response.data.text();
      const json = JSON.parse(text);
      return json.error || `Server error (${err.response.status})`;
    } catch {
      return `Server error (${err.response.status})`;
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.name.trim()) return setError("कृपया अपना पूरा नाम भरें।");
    
    if (!isValidMobile(formData.mobile))
      return setError("कृपया मान्य 10 अंकों का मोबाइल नंबर दर्ज करें।");
    if (!formData.city.trim()) return setError("कृपया शहर या देश का नाम दर्ज करें।");
    if (!formData.agree)
      return setError("कृपया घोषणा स्वीकार करने के लिए ✔ चुनें।");

    setLoading(true);

    try {
      const response = await axios.post(
        // "http://localhost:5000/api/certificate/generate",
        "https://bhaktamar-backend.onrender.com/api/certificate/generate",

        formData,
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${formData.name}_certificate.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setSuccess("🎉 आपका प्रमाणपत्र सफलतापूर्वक डाउनलोड हो गया है!");
    } catch (err) {
      const msg = await extractErrorMessage(err);
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Noto Sans Devanagari', 'Poppins', sans-serif",
        background:
          "linear-gradient(to bottom right, #fffaf0, #fff4e0, #ffeac4)",
        minHeight: "100vh",
        padding: "60px 15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          background: "linear-gradient(180deg, #fffdf7, #fffaf2, #fff4e0)",
          borderRadius: "24px",
          padding: "45px 40px",
          maxWidth: "780px",
          width: "100%",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          border: "4px solid #f7d08a",
          color: "#4b2e05",
          lineHeight: "2",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            color: "#b66b00",
            fontWeight: "800",
            marginBottom: "20px",
            fontSize: "2.1rem",
            fontFamily: "'Playfair Display', serif",
          }}
        >
           भक्तामर दिवस सहभागिता घोषणा पत्र
          <br />
          <span
            style={{
              fontSize: "1.2rem",
              color: "#7a4a0e",
              fontWeight: "600",
            }}
          >
            
          </span>
        </h1>

        {/* 🔴 Error & 🟢 Success messages */}
        {error && (
          <div
            style={{
              background: "#ffe6e6",
              color: "#a10000",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "15px",
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            {error}
          </div>
        )}
        {success && (
          <div
            style={{
              background: "#e9ffe9",
              color: "#0a6600",
              padding: "12px",
              borderRadius: "10px",
              marginBottom: "15px",
              textAlign: "center",
              fontWeight: "600",
            }}
          >
            {success}
          </div>
        )}

        {/* 📜 Declaration text */}
        <p
          style={{
            fontWeight: "600",
            color: "#5a3a0e",
            textAlign: "justify",
            fontSize: "1.05rem",
            lineHeight: "2.1",
            fontFamily: "'Noto Sans Devanagari', serif",
          }}
        >
           घोषणा पत्र (जिसे प्रत्येक सहभागी भरे और स्वीकार करे):
          <br />
          <br />
          मैं,{" "}
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="पूरा नाम"
            style={inlineInput}
            required
          />{" "}
          (पूरा नाम),
          <br />
          निवासी{" "}
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="शहर / देश"
            style={inlineInput}
            required
          />
          ,<br />
          यह पवित्र घोषणा करता / करती हूँ कि —
          <br />
          <br /> मैंने दिनांक <strong>9 अक्टूबर 2025 (गुरुवार)</strong> को
          प्रातः 7:30 बजे से प्रारंभ हुए
          <strong> “अंतर्राष्ट्रीय भक्तामर दिवस – 2025” </strong>
          के कार्यक्रम में भाग लिया तथा
          <strong> 9 बजकर 9 मिनट 9 सेकंड </strong> पर भक्तामर स्तोत्र का पाठ
          श्रद्धा एवं भक्ति-भाव से किया।
          <br />
          <br /> मैंने भक्तामर स्तोत्र के माध्यम से विश्व शांति, स्वास्थ्य,
          समृद्धि और सद्भावना की भावना से आराधना की।
          <br /> इस दिव्य पाठ के दौरान मैंने अपने मन, वचन और कर्म को शुद्ध कर
          आत्मिक शांति का अनुभव किया।
          <br /> मैं जैन धर्म के सिद्धांतों — अहिंसा, सत्य, करुणा और संयम —
          का पालन करने का संकल्प दोहराता / दोहराती हूँ।
          <br />
          <br /> मैं इस दिव्य आयोजन का सहभागी बनकर स्वयं को सौभाग्यशाली मानता /
          मानती हूँ।
          <br />
          
        </p>

        {/* 🧾 Additional input fields */}
        <form
          onSubmit={handleSubmit}
          style={{
            marginTop: "25px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >

          <label style={{ fontWeight: "600", color: "#6b4a2e" }}>
             मोबाइल नंबर:
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              placeholder="10 अंकों का मोबाइल नंबर"
              style={inputStyle}
              required
            />
          </label>

          {/* ✅ Checkbox moved to bottom */}
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginTop: "20px",
              color: "#5a3a0e",
              fontWeight: "600",
              borderTop: "1px dashed #e0c07a",
              paddingTop: "15px",
            }}
          >
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />
            मैं घोषणा करता / करती हूँ कि उपरोक्त आराधना में मैंने सम्मिलित होकर भक्तामर स्तोत्र का पाठ किया है, और इस हेतु मैं “अंतर्राष्ट्रीय भक्तामर दिवस 2025” का डिजिटल प्रमाणपत्र प्राप्त करना चाहता / चाहती हूँ
          </label>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            disabled={loading}
            style={{
              background: "linear-gradient(135deg, #d78a2c, #ffb347, #d78a2c)",
              color: "#fff",
              fontWeight: "700",
              letterSpacing: "0.5px",
              border: "none",
              borderRadius: "30px",
              padding: "13px 22px",
              cursor: "pointer",
              marginTop: "18px",
              fontSize: "1.1rem",
              boxShadow: "0 5px 14px rgba(220,140,50,0.4)",
              transition: "all 0.3s ease",
            }}
          >
            {loading ? " प्रमाणपत्र बन रहा है..." : " डिजिटल प्रमाणपत्र प्राप्त करें"}
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
}

// ✨ Inline Input Styling
const inlineInput = {
  border: "none",
  borderBottom: "2px solid #d78a2c",
  outline: "none",
  background: "transparent",
  fontSize: "1.05rem",
  color: "#4b2e05",
  padding: "3px 6px",
  minWidth: "180px",
  margin: "0 6px",
  textAlign: "center",
  borderRadius: "6px",
  transition: "all 0.3s ease",
};

// ✨ Standard Input Styling
const inputStyle = {
  width: "100%",
  marginTop: "6px",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "2px solid #f5c26b",
  outline: "none",
  fontSize: "1rem",
  background: "#fffdf8",
  color: "#4b2e05",
  transition: "all 0.3s ease",
};

export default BhaktamarDeclaration;
